import { Component } from '@angular/core';

@Component({
    selector: 'not-found',
    template: require('./not-found.html'),
    styles: [require('./not-found.scss')]
})

export default class NotFound {

    constructor() {

    }
}



// WEBPACK FOOTER //
// ./src/common/not-found/not-found.component.ts